<template>
  <div>
    <!-- 全部信息 -->
    <el-card>
      <div class="titleBox">
        <div class="titleBoxOne">
          <div>
            <span>共计:</span>
            <span>{{total}}</span>
            <span>封</span>
          </div>
          <div>
            <span>未读消息:</span>
            <span>{{unreadmessage}}</span>
            <span>封</span>
          </div>
        </div>
        <div class="titleBoxTwo">
          <el-button @click="Batch">删除</el-button>
          <el-button class="btnL" @click="wholeREAD">全部标记为已读</el-button>
        </div>
      </div>
    </el-card>
    <el-card>
      <div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="120px"  :index="count">
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column prop="name" label="状态" width="120px">
            <template slot-scope="scope">
              <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="@/images/scenic/wdxx.png"
                  alt
                  srcset
                  v-if="scope.row.State=='1'"
                />
                <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="@/images/scenic/ydxx.png"
                  alt
                  srcset
                  v-if="scope.row.State=='2'"
                />
            </template>
          </el-table-column>
          <el-table-column prop="address" label="来自于">
            <template slot-scope="scope">
               <span>{{ scope.row.FromUserID=='1'?"系统":"金飞鹰系统" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="MailContent" label="消息主题"></el-table-column>
          <el-table-column prop="CreateTime" label="收件时间"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="colRed" @click="detal(scope.row)">删除</el-button>
              <el-button type="text" @click="infoFn(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" @current-change="ListChange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 点击详情开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="34%"
      center
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form" label-width="80px">
        <div class="formItem">
          <div class="itemOne">
            <el-form-item label="来自于:" class="three">
              <el-input v-model="form.name" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item label="收件时间:" class="three">
              <el-date-picker v-model="form.value1" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="消息内容:" class="four">
            <el-input
              type="textarea"
              :autosize="{minRows:5,maxRows:7}"
              v-model="form.content"
              placeholder="消息内容"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="itemBtn">
            <el-button class="btnL" @click="checkTicFn()">确认</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </el-dialog>
    <!-- 点击详情结束 -->
  </div>
</template>

<script>
import {GetScenicNewMailList,deleteSenicNewMail,getScenicNewMailInfo,deleteAllScenicNewMail,readAllsenicNewMail} from '@/request/scenic.js'
import M from 'minimatch';
import {MessageBox,} from 'element-ui'
export default {
  data() {
    return {
      infoDialogVisible: false, // 订单详情
      tableData: [
     
      ],
      multipleSelection: [],
      form: {
        name: "",
        value1: "",
        content:''
      },
      data:{
        token:window.sessionStorage.getItem('Token'),
        page_size:10,
        page:1
      },
      total:0,
      unreadmessage:0
    };
  },
  created(){
    this.getList()
  },
  methods: {
    count(index){
      return (this.data.page - 1) * this.data.page_size + index + 1
    },
    // 全部已读
    wholeREAD(){
      var NewMailID = ''
      this.tableData.map(item=>{
        NewMailID += item.NewMailID + ','
      })
      if (NewMailID.length > 0) {
        NewMailID = NewMailID.substr(0,NewMailID.length - 1);
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        NewMailID:NewMailID
      }
      readAllsenicNewMail(data).then(res=>{
        if(res.data.rcode==200){
          this.getList()
          this.$message.success('操作成功')
        }else{
          this.$message.error('当前页，全部已读')
        }
      })
    },
    // 批量删除
    Batch(){
      var NewMailID = ''
      if(this.multipleSelection.length==0){
        this.$message.error('请选择删除列表')
        return false
      }
      this.multipleSelection.map(item=>{
        NewMailID += item.NewMailID + ','
      })
      if (NewMailID.length > 0) {
        NewMailID = NewMailID.substr(0,NewMailID.length - 1);
      }
      MessageBox('此操作将删除该短信, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            NewMailID:NewMailID
          }
          deleteAllScenicNewMail(data).then(res=>{
            if(res.data.rcode==200){
              this.getList()
              this.$message.success('批量删除成功')
            }
          })
        }).catch(() => {
                 
       });
    },
    // 删除
    detal(row){
      MessageBox('此操作将删除该短信, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            NewMailID:row.NewMailID
          }
          deleteSenicNewMail(data).then(res=>{
            console.log(res)
            if(res.data.rcode==200){
              this.getList()
              this.$message.success('删除成功')
            }
          })
        }).catch(() => {
                 
        });
    },
    // 分页
    ListChange(e){
      this.data.page = e
      this.getList()
    },
    getList(){
      GetScenicNewMailList(this.data).then(res=>{
        console.log(res)
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
          this.unreadmessage = res.data.result.unreadmessage
        }
      })
    },
    // 点击详情
    infoFn(row) {
      this.infoDialogVisible = true;
      this.form.value1 = row.CreateTime
      let data = {
        token:window.sessionStorage.getItem('Token'),
        NewMailID:row.NewMailID
      }
      getScenicNewMailInfo(data).then(res=>{
        if(res.data.rcode==200){
          this.form.name = res.data.result.FromUserID=='1'?'金飞鹰系统':'系统'
          this.form.content = res.data.result.MailContent
        }
      })
    },
    // 点击详情X
    infoHandleClose() {
      this.getList()
      this.infoDialogVisible = false;
    },
    // 全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.formItem {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .itemOne {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-input {
      width: 215px;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 40px;
    margin-bottom: 0px;
    .btnL {
      width: 110px;
      border: none;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.colRed {
  color: #ff4d4f;
}
.titleBox {
  .titleBoxOne {
    display: flex;
    margin-bottom: 20px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    > div > span:nth-child(2) {
      color: #689af2;
      margin: 0 10px;
    }
    > div:nth-child(2) {
      > span:nth-child(1) {
        color: #4ecb73;
        margin-left: 20px;
      }
    }
  }
  .titleBoxTwo {
    .el-button {
      width: 110px;
      background: #ffffff;
      border: 1px solid #e74c3c;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #e74c3c;
    }
    .btnL {
      width: 150px;
      margin-left: 20px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #246deb;
    }
  }
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>